// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullscreen-loader-overlay {
  position: fixed;
  top: var(--navbar-height, 60px); /* Start below the navbar */
  left: 0;
  width: 100%;
  height: calc(100% - var(--navbar-height, 60px)); /* Adjust height to account for navbar */
  background-color: rgba(20, 8, 20, 0.95); /* Match the dark theme background with transparency */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Lower z-index so navbar (typically z-index: 1030) can show through */
  backdrop-filter: blur(5px); /* Add a subtle blur effect */
}

.fullscreen-loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.loader-spinner {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.spinner-ring {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid transparent;
  border-radius: 50%;
  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.spinner-ring:nth-child(1) {
  border-top-color: #ea3377; /* Match the primary theme color */
  animation-delay: -0.45s;
}

.spinner-ring:nth-child(2) {
  border-top-color: #ff4554;
  animation-delay: -0.3s;
}

.spinner-ring:nth-child(3) {
  border-top-color: #b8e986;
  animation-delay: -0.15s;
}

.spinner-ring:nth-child(4) {
  border-top-color: rgba(255, 255, 255, 0.3);
  animation-delay: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loader-message {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .fullscreen-loader-overlay {
    top: var(--navbar-mobile-height, 52px); /* Use mobile navbar height */
    height: calc(100% - var(--navbar-mobile-height, 52px));
  }
  
  .loader-spinner {
    width: 60px;
    height: 60px;
  }
  
  .spinner-ring {
    width: 48px;
    height: 48px;
    border-width: 6px;
    margin: 6px;
  }
  
  .loader-message {
    font-size: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/FullScreenLoader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,+BAA+B,EAAE,2BAA2B;EAC5D,OAAO;EACP,WAAW;EACX,+CAA+C,EAAE,wCAAwC;EACzF,uCAAuC,EAAE,sDAAsD;EAC/F,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,uEAAuE;EACtF,0BAA0B,EAAE,6BAA6B;AAC3D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;EAC7D,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,sCAAsC,EAAE,6BAA6B;IACrE,sDAAsD;EACxD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".fullscreen-loader-overlay {\n  position: fixed;\n  top: var(--navbar-height, 60px); /* Start below the navbar */\n  left: 0;\n  width: 100%;\n  height: calc(100% - var(--navbar-height, 60px)); /* Adjust height to account for navbar */\n  background-color: rgba(20, 8, 20, 0.95); /* Match the dark theme background with transparency */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; /* Lower z-index so navbar (typically z-index: 1030) can show through */\n  backdrop-filter: blur(5px); /* Add a subtle blur effect */\n}\n\n.fullscreen-loader-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.loader-spinner {\n  position: relative;\n  width: 80px;\n  height: 80px;\n  margin-bottom: 20px;\n}\n\n.spinner-ring {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 64px;\n  height: 64px;\n  margin: 8px;\n  border: 8px solid transparent;\n  border-radius: 50%;\n  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n}\n\n.spinner-ring:nth-child(1) {\n  border-top-color: #ea3377; /* Match the primary theme color */\n  animation-delay: -0.45s;\n}\n\n.spinner-ring:nth-child(2) {\n  border-top-color: #ff4554;\n  animation-delay: -0.3s;\n}\n\n.spinner-ring:nth-child(3) {\n  border-top-color: #b8e986;\n  animation-delay: -0.15s;\n}\n\n.spinner-ring:nth-child(4) {\n  border-top-color: rgba(255, 255, 255, 0.3);\n  animation-delay: 0;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loader-message {\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 0.7;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .fullscreen-loader-overlay {\n    top: var(--navbar-mobile-height, 52px); /* Use mobile navbar height */\n    height: calc(100% - var(--navbar-mobile-height, 52px));\n  }\n  \n  .loader-spinner {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .spinner-ring {\n    width: 48px;\n    height: 48px;\n    border-width: 6px;\n    margin: 6px;\n  }\n  \n  .loader-message {\n    font-size: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
